import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appText]',
  host: { class: 'app-text' },
})
export class TextDirective {
  @Input('appText') text = 1;

  @HostBinding('class') get class(): string {
    return `app-text-${this.text}`;
  }
}
